import React from 'react';
import { Link } from '@tanstack/react-router';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

interface ModuleNavLabelProps {
  namespace: string;
  fallback: string;
  href: string;
  isMocked?: boolean;
}

/** Sidebar link label that resolves from a module i18n namespace at render time. */
export const ModuleNavLabel: React.FC<ModuleNavLabelProps> = ({
  namespace,
  fallback,
  href,
  isMocked = false
}) => {
  const { t } = useTranslation(namespace);
  const label =
    t('navigation.label', { defaultValue: '' }) ||
    t('navigation.title', { defaultValue: fallback });

  return (
    <Link to={href} className="flex items-center gap-2" style={{ fontSize: '14px' }}>
      {isMocked && <Tag color="blue">Mocked</Tag>}
      {label}
    </Link>
  );
};
